import React, { useEffect } from 'react';
import { useLocation } from 'react-router';
import fr from 'facet-rest';
import MetaCollectionFormDrawer from '../../UI/Meta/MetaForm/MetaCollectionFormDrawer';
import useCollection from '../../../Hooks/useCollection';
import { displayErrorMessage, displaySuccess } from '../../../Helpers/FacetNotificationManager';
import { addQuery, QueryVal, removeQuery } from '../../../Helpers/Query';
import closeModal from '../../../Helpers/ModalHelper';
import { AgentActionItemOverride } from '../../../Overrides/ActionItem';

/**
 * Metaform-based modal for editing tasks. Expects a self link in the `actionItemLink` query parameter.
 */
const TaskModal = () => {
  const { collection, setCollection } = useCollection();
  const location = useLocation();
  const link = QueryVal('actionItemLink');

  const fetchData = async () => {
    if (link) {
      try {
        const url = atob(link);
        const coll = fr.collection(await fr.http.Get(url), AgentActionItemOverride);
        if (coll.resources().length() === 0) {
          throw new Error('Fetching tasks did not return any resources.');
        }

        setCollection(coll);
      } catch (e) {
        displayErrorMessage(e, 'Could not fetch action items');
      }
    }
  };

  useEffect(() => {
    fetchData();
  }, [location.search]);

  return (
    <MetaCollectionFormDrawer
      open
      collection={collection}
      anchor="right"
      loading={!collection}
      title="Edit Task"
      onClose={() => {
        removeQuery('actionItemLink');
        closeModal();
      }}
      onSubmit={() => {
        displaySuccess('Task updated');
        removeQuery('actionItemLink');
        addQuery({
          refresh: 'actionItem',
        });
        closeModal();
      }}
    />
  );
};

export default TaskModal;
